var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertTriangleGrayscaleDarkest16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98257 3.48472L1.33591 12.9114C1.21948 13.113 1.15788 13.3416 1.15723 13.5744C1.15658 13.8072 1.2169 14.0361 1.33219 14.2384C1.44748 14.4407 1.61372 14.6092 1.81438 14.7273C2.01503 14.8454 2.24311 14.9088 2.47591 14.9114H13.7692C14.002 14.9088 14.2301 14.8454 14.4308 14.7273C14.6314 14.6092 14.7977 14.4407 14.913 14.2384C15.0282 14.0361 15.0886 13.8072 15.0879 13.5744C15.0873 13.3416 15.0257 13.113 14.9092 12.9114L9.26257 3.48472C9.14372 3.2888 8.97639 3.1268 8.7767 3.01438C8.57702 2.90196 8.35173 2.8429 8.12257 2.8429C7.89342 2.8429 7.66813 2.90196 7.46844 3.01438C7.26876 3.1268 7.10142 3.2888 6.98257 3.48472Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12305 6.91138V9.57804",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12305 12.2447H8.13055",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertTriangleGrayscaleDarkest16X16);
export default __webpack_public_path__ + "static/media/icon-alert-triangle-grayscaleDarkest-16x16.83630852b64191cddcf8e7c43a269bb9.svg";
export { ForwardRef as ReactComponent };